/**
 * Utility class for executing js-driven changes in css3 mediaqueries
 * Measures and writes/triggers a custom "changeProfile" event when
 * the window is resized
 */

define('common/js/lib/Serum.Profile',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'common/js/lib/jquery/plugins/jquery-throttle-debounce/1.1/jquery-throttle-debounce.min'
], function($, Pubsub) {
  'use strict';

  // @private
  var PROFILES = {
      500 : 'w320',
      720 : 'w500',
      980 : 'w720',
      1150 : 'w980',
      '-1' : 'w1150'
    },
    currentProfile,
    options = {
      debounceDelay: 500
    };

  // @public
  function initialize (o) {
    $.extend(options, o);
    currentProfile = findProfile();
    setupEvents();
  }

  // @public
  function setupEvents () {
    $(window)
      .on('resize', $.debounce(options.debounceDelay, triggerResize))
      .on('focus', triggerProfile)
      .on('unload', destroy);
    Pubsub.subscribe(Pubsub.topics.DID_RESIZE, triggerProfile);
  }

  // @public
  function destroy() {
    var $win = $(window);
    $win.off('resize');
    $win.off('focus', triggerProfile);
    Pubsub.unsubscribe(Pubsub.topics.DID_RESIZE, triggerProfile);
  }

  // @public
  function triggerProfile (profileAndWidth) {
    var profile = profileAndWidth.profile || findProfile(getWidth());
    // do not trigger a new profile, unless its width is greater than the previous
    if (currentProfile !== profile) {
      Pubsub.publish(Pubsub.topics.CHANGED_PROFILE, {newProfile:profile, oldProfile:currentProfile});
      currentProfile = profile;
    }
  }

  // @public
  function triggerResize() {
    var width = getWidth();
    Pubsub.publish(Pubsub.topics.DID_RESIZE, {
      width: width,
      profile: findProfile(width)
    });
  }

  // @public
  function getProfile() {
    return currentProfile;
  }

  // @public
  function getProfiles() {
    return PROFILES;
  }

  // @private
  function getWidth() {
    return $(window).width();
  }

  // @private
  function findProfile (width) {
    width = width || getWidth();

    var profile = PROFILES['-1'],    // use default profile
      found = false;
    $.each(PROFILES, function(w, p){  // .. or select profile based on $('.page').width()
      if(!found && width < w) {
        profile = p;
        found = true;
      }
    });
    return profile;
  }


  // public api object
  return {
    initialize : initialize,
    setupEvents : setupEvents,
    destroy : destroy,
    getProfile : getProfile,
    getProfiles : getProfiles,
    triggerProfile : triggerProfile
  };

});
